import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["row", "icon"]

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()

    const rowId = event.currentTarget.dataset.rowId
    const expandRow = this.rowTargets.find(r => r.dataset.rowId === rowId)

    if (expandRow) {
      const isHidden = expandRow.classList.contains("hidden")
      expandRow.classList.toggle("hidden", !isHidden)

      // Rotate the icon
      const icon = this.iconTargets.find(i => i.dataset.rowId === rowId)
      if (icon) {
        icon.classList.toggle("rotate-180", isHidden)
      }
    }
  }

  expandAll() {
    this.rowTargets.forEach(row => row.classList.remove("hidden"))
    this.iconTargets.forEach(icon => icon.classList.add("rotate-180"))
  }

  collapseAll() {
    this.rowTargets.forEach(row => row.classList.add("hidden"))
    this.iconTargets.forEach(icon => icon.classList.remove("rotate-180"))
  }
}
